import React from 'react';
import { Text, TextType } from "../Text";

export type DescriptionProps = {
  description?: string | React.ReactNode;
  descriptionType: TextType;
  descriptionClassName?: string;
}

export const Description = ({ description, descriptionType, descriptionClassName }: DescriptionProps) => {

  if (!description) return null;

  if (typeof description === 'string') {
    return description.length > 0 ? <Text type={descriptionType} className={descriptionClassName}>{description}</Text> : null;
  }

  return <Text as="div" type={descriptionType} className={descriptionClassName}>{description}</Text>

}
